module.exports = __webpack_public_path__ + "static/pernos-prod-811726c2f2b732cc71d121184476eb8a.png";